export const DOCUMENT_STATUSES = {
  new: 'new',
  signed: 'signed',
  approved: 'approved',
  rejected: 'rejected',
  cancelled: 'cancelled',
  sentForSign: 'sent_for_sign',
  sentForApprove: 'sent_for_approve',
  waitingForYourSign: 'waiting_for_your_sign',
  waitingForContractorSign: 'waiting_for_contractor_sign',
  waitingForApprove: 'waiting_for_approve',
  waitingForView: 'waiting_for_view',
  viewed: 'viewed',
  filled: 'filled',
  sentForFill: 'sent_for_fill',
  waitingForFill: 'waiting_for_fill'
}

export const DOCUMENT_STATES = {
  NEW: 'new',
  SENT: 'sent',
  SIGNED: 'signed'
}

export const documentStates = [
  {
    value: 'signed',
    text: 'Підписано',
    background: 'rgba(33, 150, 83, 0.08)',
    color: '#219653'
  },
  {
    value: 'new',
    text: 'Новий',
    background: 'rgba(0, 0, 0, 0.08)',
    color: '#000'
  },
  {
    value: 'sent',
    text: 'Надісланий',
    background: 'rgba(4, 174, 212, 0.08)',
    color: '#04aed4'
  }
]

export const DOCUMENT_STATUSES_SELECT = [
  {
    text: 'Завантажений',
    value: 'new'
  },
  {
    text: 'Підписано',
    value: 'signed'
  },
  {
    text: 'Погоджено',
    value: 'approved'
  },
  {
    text: 'Відхилено',
    value: 'rejected'
  },
  {
    text: 'Анульовано',
    value: 'cancelled'
  },
  {
    text: 'Надісланий на підпис',
    value: 'sent_for_sign'
  },
  {
    text: 'Надісланий на погодження',
    value: 'sent_for_approve'
  },
  {
    text: 'Очікує вашого підпису',
    value: 'waiting_for_your_sign'
  },
  {
    text: 'Очікує підпису контрагента(ів)',
    value: 'waiting_for_contractor_sign'
  },
  {
    text: 'Очікує на погодження',
    value: 'waiting_for_approve'
  },
  {
    text: 'Переглянуто',
    value: 'viewed'
  },
  {
    text: 'Очікує перегляду',
    value: 'waiting_for_view'
  },
  {
    text: 'Заповнено',
    value: 'filled'
  },
  {
    text: 'Надіслано на заповнення',
    value: 'sent_for_fill'
  },
  {
    text: 'Очікує заповнення',
    value: 'waiting_for_fill'
  }
]

export const SIGNATURE_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external'
}

export const BUNDLE_STATUSES = {
  CREATED: 'created',
  PENDING: 'pending',
  COMPLETED: 'completed'
}